import { render, staticRenderFns } from "./WipDialog.vue?vue&type=template&id=ade76ba2&scoped=true&"
import script from "./WipDialog.vue?vue&type=script&lang=js&"
export * from "./WipDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ade76ba2",
  null
  
)

export default component.exports